import { flex } from "styled-system";
export const getOptionColor = ({ isDisabled = false, isError = false, isFocused = false, isSelected = false }, { colors: { inputColors } }) => {
    if (isDisabled)
        return inputColors.dropDownOptionDisabled;
    if (isError)
        return inputColors.dropDownOptionError;
    if (isFocused)
        return inputColors.dropDownOptionFocused;
    if (isSelected)
        return inputColors.dropDownOptionSelected;
    return inputColors.dropDownOptionText;
};
export const getBorderColor = ({ isError, isFocused }, theme) => {
    const { colors: { inputColors }, } = theme;
    if (isError)
        return inputColors.inputErrorBorder;
    return isFocused ? inputColors.inputFocusBorder : inputColors.inputBorder;
};
export const customStyles = (theme, overrideStyles) => {
    const { colors: { inputColors }, } = theme;
    return {
        clearIndicator: (provided) => (Object.assign(Object.assign({}, provided), { "&:hover": {
                color: inputColors.dropDownIndicatorHover,
            }, alignItems: "center", color: inputColors.dropDownIndicator, height: "30px", padding: "6px", width: "30px" })),
        container: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), { display: flex, flex: 2 }), overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.container)),
        control: (provided, state) => (Object.assign(Object.assign(Object.assign({}, provided), { "&:hover": {
                borderColor: getBorderColor(state, theme),
            }, backgroundColor: state.isDisabled ? inputColors.inputDisabledBackground : inputColors.inputBackground, borderColor: getBorderColor(state, theme), boxShadow: state.isFocused ? theme.shadows.searchBox.contentShadow : "none", flex: 1, minHeight: "32px", paddingLeft: "8px", paddingRight: "0" }), overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.control)),
        dropdownIndicator: (provided) => (Object.assign(Object.assign({}, provided), { "&:hover": {
                color: inputColors.dropDownIndicatorHover,
            }, alignItems: "center", color: inputColors.dropDownIndicator, height: "30px", padding: "6px", width: "30px" })),
        groupHeading: (provided) => (Object.assign(Object.assign({}, provided), { fontSize: "12px" })),
        input: (provided, state) => (Object.assign(Object.assign({}, provided), { color: state.isDisabled ? inputColors.inputDisabledText : inputColors.inputText })),
        menu: (provided) => (Object.assign(Object.assign({}, provided), { backgroundColor: inputColors.dropDownBackground, overflow: "hidden" })),
        noOptionsMessage: (provided) => (Object.assign(Object.assign({}, provided), { color: inputColors.noOptionsText })),
        option: (provided, state) => (Object.assign(Object.assign({}, provided), { backgroundColor: state.isFocused
                ? inputColors.dropDownOptionFocusedBackground
                : inputColors.dropDownOptionBackground, color: getOptionColor(state, theme) })),
        placeholder: (provided) => (Object.assign(Object.assign({}, provided), { color: inputColors.inputPlaceholder })),
        singleValue: (provided, state) => (Object.assign(Object.assign({}, provided), { color: state.isDisabled ? inputColors.inputDisabledText : inputColors.inputText })),
        valueContainer: (provided, state) => (Object.assign(Object.assign({}, provided), { color: getOptionColor(state, theme) })),
    };
};
